// extracted by mini-css-extract-plugin
export var arrows = "_6m-5";
export var decrementer = "_6m-9";
export var disabled = "_6m-3";
export var error = "_6m-1";
export var hiddenText = "_6m-a";
export var incrementer = "_6m-8";
export var input = "_6m-7";
export var inputWrapper = "_6m-0";
export var leadingIcon = "_6m-b";
export var readonly = "_6m-2";
export var regular = "_6m-6";
export var small = "_6m-4";